export const UserConnexionStyles = {
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
};



// WEBPACK FOOTER //
// ./src/pages/Support/User/components/Connexion/styles.js